// Tippy.js Initialization
(function() {
	if (typeof document === 'undefined') {
		return;
	}
	
	function initTippy() {
		if (typeof window.tippy === 'undefined') {
			setTimeout(initTippy, 100);
			return;
		}
		
		var elements = document.querySelectorAll('[data-tippy-content]');
		
		if (elements.length === 0) {
			return;
		}
		
		// Detect if device is touch-based
		var isTouchDevice = function() {
			return (('ontouchstart' in window) ||
					(navigator.maxTouchPoints > 0) ||
					(navigator.msMaxTouchPoints > 0));
		};
		
		var isTouch = isTouchDevice();
		
		elements.forEach(function(element) {
			if (!element._tippy) {
				try {
					var config = {
						content: element.getAttribute('data-tippy-content'),
						allowHTML: true,
						theme: 'light',
						hideOnClick: true,
						hideOnEsc: true,
						duration: [0, 0]
					};
					
					// Use click trigger on touch devices, hover on desktop
					if (isTouch) {
						config.trigger = 'click';
						config.interactive = true;
					}
					
					window.tippy(element, config);
				} catch(e) {
					// silently fail
				}
			}
		});
		
		// Hide all tooltips on scroll
		var hideAllTooltips = function() {
			elements.forEach(function(element) {
				if (element._tippy) {
					element._tippy.hide();
				}
			});
		};
		
		document.addEventListener('scroll', hideAllTooltips, true);
	}
	
	// Try to initialize immediately
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTippy);
	} else {
		initTippy();
	}
	
	// Also try on window load as fallback
	window.addEventListener('load', function() {
		setTimeout(initTippy, 100);
	});
})();

// Main JS entry point: mobile menu, accordions, and accessible nav behavior
(function(){
	if ( typeof document === 'undefined' ) return;

	var body = document.body;
	var mobileToggle = document.getElementById('mobile-menu-toggle');
	var mobileMenu = document.getElementById('mobile-menu');
	var mobileClose = mobileMenu ? mobileMenu.querySelector('.mobile-close') : null;

	function openMobileMenu(){
		if (!mobileMenu) return;
		mobileMenu.setAttribute('aria-hidden','false');
		if ( mobileToggle ) mobileToggle.setAttribute('aria-expanded','true');
		body.classList.add('mobile-menu-open');
		if ( mobileToggle ) mobileToggle.classList.add('open');
		// trap focus if possible
		var inner = mobileMenu.querySelector('.mobile-menu-inner');
		if ( inner && inner.focus ) inner.focus();
	}

	function closeMobileMenu(){
		if (!mobileMenu) return;
		mobileMenu.setAttribute('aria-hidden','true');
		mobileToggle.setAttribute('aria-expanded','false');
		body.classList.remove('mobile-menu-open');
		mobileToggle.classList.remove('open');
		mobileToggle.focus();
	}

	if ( mobileToggle && mobileMenu ){
		mobileToggle.addEventListener('click', function(e){
			var isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
			if ( isOpen ) closeMobileMenu(); else openMobileMenu();
		});
	}

	if ( mobileClose ){ mobileClose.addEventListener('click', closeMobileMenu); }

	// Close when clicking the overlay (i.e., the mobile-menu element but outside the inner)
	if ( mobileMenu ){
		mobileMenu.addEventListener('click', function(e){
			var inner = mobileMenu.querySelector('.mobile-menu-inner');
			if ( inner && !inner.contains(e.target) ){
				closeMobileMenu();
			}
		});
	}

	// Close on ESC
	document.addEventListener('keydown', function(e){
		if ( e.key === 'Escape' && mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false' ){
			closeMobileMenu();
		}
	});

	// Close mobile menu when viewport becomes wider than 900px
	window.addEventListener('resize', function(){
		if ( window.innerWidth > 900 && mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false' ){
			closeMobileMenu();
		}
	});

	// Set active menu item based on current URL
	function setActiveMenuItem(){
		var currentUrl = window.location.href;
		var menuItems = document.querySelectorAll('.global-menu .menu-item > a');
		menuItems.forEach(function(link){
			var href = link.getAttribute('href');
			// Check if current URL matches the link href
			if ( currentUrl.indexOf(href) !== -1 && href !== '/' ){
				link.closest('.menu-item').classList.add('active');
			} else {
				link.closest('.menu-item').classList.remove('active');
			}
		});
	}
	if ( document.readyState === 'loading' ){
		document.addEventListener('DOMContentLoaded', setActiveMenuItem);
	} else {
		setActiveMenuItem();
	}

	// Mobile accordion behavior - DISABLED: no accordions
	if ( false ) {
	document.addEventListener('click', function(e){
		var acc = e.target.closest && e.target.closest('.mobile-accordion');
		if ( acc ){
			var expanded = acc.getAttribute('aria-expanded') === 'true';
			acc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
			var parent = acc.parentNode;
			if ( parent ){ parent.classList.toggle('open', !expanded); }
		}
	});
	}

	// Desktop keyboard menu accessibility: toggle submenu with Enter/Space - DISABLED: no dropdowns
	if ( false ) {
	document.addEventListener('click', function(e){
		var chev = e.target.closest && e.target.closest('.chev-toggle');
		if ( chev ){
			var li = chev.closest('.menu-item');
			if ( li ){
				var anchor = li.querySelector('a[aria-expanded]');
				var expanded = anchor.getAttribute('aria-expanded') === 'true';
				anchor.setAttribute('aria-expanded', expanded ? 'false' : 'true');
				li.classList.toggle('active', !expanded);
			}
		}
	});
	}

})();

// Accessible accordion behavior for page-impact accordions
(function(){
	if ( typeof document === 'undefined' ) return;
	var accRoot = document.querySelector('.accordion');
	if ( !accRoot ) return;

	var items = Array.prototype.slice.call(accRoot.querySelectorAll('.accordion-item'));
	var headers = items.map(function(it){ return it.querySelector('.accordion-header'); });

	function closePanel(item){
		var h = item.querySelector('.accordion-header');
		var p = item.querySelector('.accordion-panel');
		if ( h && p ){
			h.setAttribute('aria-expanded','false');
			p.hidden = true;
			p.setAttribute('aria-hidden','true');
			var icon = h.querySelector('.accordion-icon'); if ( icon ) icon.textContent = '+';
			item.classList.remove('open');
		}
	}

	function openPanel(item){
		var h = item.querySelector('.accordion-header');
		var p = item.querySelector('.accordion-panel');
		if ( h && p ){
			h.setAttribute('aria-expanded','true');
			p.hidden = false;
			p.setAttribute('aria-hidden','false');
			var icon = h.querySelector('.accordion-icon'); if ( icon ) icon.textContent = '\u2212';
			item.classList.add('open');
		}
	}

	headers.forEach(function(h, idx){
		if ( !h ) return;
		// make whole header clickable
		h.addEventListener('click', function(e){
			var expanded = h.getAttribute('aria-expanded') === 'true';
			if ( expanded ) closePanel(items[idx]); else openPanel(items[idx]);
		});

		// keyboard support
		h.addEventListener('keydown', function(e){
			// Toggle on Enter or Space
			if ( e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' ){
				e.preventDefault(); h.click();
				return;
			}
			// Move focus
			if ( e.key === 'ArrowDown' ){ e.preventDefault(); var next = headers[(idx+1) % headers.length]; if ( next ) next.focus(); return; }
			if ( e.key === 'ArrowUp' ){ e.preventDefault(); var prev = headers[(idx-1+headers.length) % headers.length]; if ( prev ) prev.focus(); return; }
			if ( e.key === 'Home' ){ e.preventDefault(); if ( headers[0] ) headers[0].focus(); return; }
			if ( e.key === 'End' ){ e.preventDefault(); if ( headers[headers.length-1] ) headers[headers.length-1].focus(); return; }
		});
	});

	// start all closed
	items.forEach(function(it){ closePanel(it); });
})();

// Tabbed content behavior: accessible tabs (click + keyboard)
(function(){
  if ( typeof document === 'undefined' ) return;
  var tabContainers = document.querySelectorAll('.tabbed-content');
  if ( !tabContainers || !tabContainers.length ) return;

  tabContainers.forEach(function(container){
    var tabs = Array.prototype.slice.call(container.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(container.querySelectorAll('[role="tabpanel"]'));
    if ( !tabs.length || !panels.length ) return;

    function activateTab(tab){
      tabs.forEach(function(t){
        var sel = t === tab;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
      });
      panels.forEach(function(p){
        p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
      });
      tab.focus();
    }

    // click
    tabs.forEach(function(t){
      t.addEventListener('click', function(e){
        activateTab(t);
      });

      t.addEventListener('keydown', function(e){
        var idx = tabs.indexOf(t);
        if ( e.key === 'ArrowRight' || e.key === 'Right' ){
          e.preventDefault();
          var next = tabs[(idx + 1) % tabs.length];
          activateTab(next);
        }
        if ( e.key === 'ArrowLeft' || e.key === 'Left' ){
          e.preventDefault();
          var prev = tabs[(idx - 1 + tabs.length) % tabs.length];
          activateTab(prev);
        }
        if ( e.key === 'Home' ){
          e.preventDefault();
          activateTab(tabs[0]);
        }
        if ( e.key === 'End' ){
          e.preventDefault();
          activateTab(tabs[tabs.length - 1]);
        }
      });
    });

    // ensure initial state
    var initial = tabs.find(function(t){ return t.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    activateTab(initial);
  });
})();

// Smooth scroll for subnav links and deeplinks with offset for sticky subnav
(function(){
	if ( typeof document === 'undefined' ) return;

	function getSubnavOffset() {
		var subnav = document.querySelector('.subnav');
		if (!subnav) return 0;
		return subnav.offsetHeight + 180; // 110px additional offset for larger header
	}

	function smoothScrollToAnchor(targetId, offset) {
		var target = document.getElementById(targetId);
		if (!target) return;

		var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
		
		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	}

	// Handle clicks on subnav links
	document.addEventListener('click', function(e) {
		var link = e.target.closest('.subnav-link');
		if (!link) return;
		
		var href = link.getAttribute('href');
		if (!href || !href.startsWith('#')) return;
		
		e.preventDefault();
		var targetId = href.substring(1);
		var offset = getSubnavOffset();
		smoothScrollToAnchor(targetId, offset);
		
		// Update URL without triggering scroll
		if (history.pushState) {
			history.pushState(null, null, href);
		}
	});

	// Handle deeplinks on page load
	function handleDeeplink() {
		var hash = window.location.hash;
		if (!hash || hash.length <= 1) return;
		
		var targetId = hash.substring(1);
		var offset = getSubnavOffset();
		
		// Small delay to ensure subnav is rendered and positioned
		setTimeout(function() {
			smoothScrollToAnchor(targetId, offset);
		}, 100);
	}

	// Handle deeplinks on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', handleDeeplink);
	} else {
		handleDeeplink();
	}

	// Handle hash changes (back/forward navigation)
	window.addEventListener('hashchange', function() {
		var hash = window.location.hash;
		if (!hash || hash.length <= 1) return;
		
		var targetId = hash.substring(1);
		var offset = getSubnavOffset();
		smoothScrollToAnchor(targetId, offset);
	});

	// Set active subnav link based on scroll position
	function updateActiveSubnav() {
		var subnav = document.querySelector('.subnav');
		if (!subnav) return;

		var subnavLinks = subnav.querySelectorAll('a[href^="#"]');
		if (!subnavLinks.length) return;

		var offset = getSubnavOffset();
		var found = false;

		// Check each section in reverse order (bottom to top)
		for (var i = subnavLinks.length - 1; i >= 0; i--) {
			var link = subnavLinks[i];
			var href = link.getAttribute('href');
			if (!href) continue;

			var targetId = href.substring(1);
			var target = document.getElementById(targetId);
			if (!target) continue;

			var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
			// Subtract 10px buffer to account for positioning variations
			if (window.pageYOffset >= targetTop - offset - 10) {
				// This section is active
				subnavLinks.forEach(function(l) {
					l.classList.remove('active');
				});
				link.classList.add('active');
				found = true;
				break;
			}
		}

		// If no section found, clear all active
		if (!found) {
			subnavLinks.forEach(function(l) {
				l.classList.remove('active');
			});
		}
	}

	// Listen to scroll events
	window.addEventListener('scroll', updateActiveSubnav);
	
	// Initialize on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateActiveSubnav);
	} else {
		updateActiveSubnav();
	}
})();

// Interactive diagram slideshow: navigate slides and fade images
(function(){
	if ( typeof document === 'undefined' ) return;
	var diagram = document.getElementById('interactive-diagram');
	if ( !diagram ) return;

	var slideShow = diagram.querySelector('#slide-show');
	var imgsContainers = diagram.querySelectorAll('.interactive-imgs');
	var prevBtn = diagram.querySelector('.slide-nav.prev');
	var nextBtn = diagram.querySelector('.slide-nav.next');

	if ( !slideShow || !imgsContainers.length ) return;

	function getVisibleImgsContainer(){
		for ( var i = 0; i < imgsContainers.length; i++ ){
			if ( window.getComputedStyle(imgsContainers[i]).display !== 'none' ){
				return imgsContainers[i];
			}
		}
		return imgsContainers[0];
	}

	var slides = Array.prototype.slice.call(slideShow.querySelectorAll('.slide'));
	if ( !slides.length ) return;

	function showSlide(index){
		// Clamp index
		index = (index + slides.length) % slides.length;

		// Update active slide
		slides.forEach(function(slide, i){
			if ( i === index ) {
				slide.classList.add('active');
			} else {
				slide.classList.remove('active');
			}
		});

		// Update active image in visible container
		var imgsContainer = getVisibleImgsContainer();
		var images = Array.prototype.slice.call(imgsContainer.querySelectorAll('img'));
		var currentSlide = slides[index];
		var dataId = currentSlide.getAttribute('data-id');
		images.forEach(function(img){
			if ( img.getAttribute('data-id') === dataId ) {
				img.classList.add('active');
			} else {
				img.classList.remove('active');
			}
		});
	}

	function getCurrentIndex(){
		for ( var i = 0; i < slides.length; i++ ){
			if ( slides[i].classList.contains('active') ) return i;
		}
		return 0;
	}

	if ( prevBtn ){
		prevBtn.addEventListener('click', function(){
			var current = getCurrentIndex();
			showSlide(current - 1);
		});
	}

	if ( nextBtn ){
		nextBtn.addEventListener('click', function(){
			var current = getCurrentIndex();
			showSlide(current + 1);
		});
	}

	// Handle hotspot clicks
	var hotspots = Array.prototype.slice.call(diagram.querySelectorAll('.label-hotspot'));
	hotspots.forEach(function(hotspot){
		hotspot.addEventListener('click', function(e){
			e.stopPropagation();
			var slideId = this.getAttribute('data-slide');
			if ( slideId ) {
				var found = false;
				// Find the slide index that matches this data-slide
				for ( var i = 0; i < slides.length; i++ ){
					if ( slides[i].getAttribute('data-id') === slideId ){
						showSlide(i);
						found = true;
						break;
					}
				}
				// If no match found, go to first slide
				if ( !found ) {
					showSlide(0);
				}
			}
		});
	});

	// Initialize with first image
	showSlide(0);
})();

// Detect sticky state on .subnav and apply is-sticky class
(function(){
	if ( typeof document === 'undefined' ) return;
	
	function initStickyDetection(){
		var subnav = document.querySelector('.subnav');
		if ( !subnav ) return;

		function checkStickyState(){
			var rect = subnav.getBoundingClientRect();
			// When sticky, top will be at or near the CSS 'top' value (110px)
			// When scrolled past, top will be negative; when in normal flow below, top will be much larger
			if ( rect.top <= 137 && rect.top >= 0 ) {
				subnav.classList.add('is-sticky');
			} else {
				subnav.classList.remove('is-sticky');
			}
		}

		window.addEventListener('scroll', checkStickyState, { passive: true });
		checkStickyState();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', initStickyDetection);
	} else {
		initStickyDetection();
	}
})();

// Smooth scroll to form functionality for CTA buttons
(function(){
	if ( typeof document === 'undefined' ) return;

	function smoothScrollTo(target) {
		if (!target) return;
		
		var header = document.querySelector('header') || document.querySelector('.header');
		var headerOffset = header ? header.offsetHeight + 20 : 100;
		var elementPosition = target.getBoundingClientRect().top;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}

	function handleFormScroll(e) {
		e.preventDefault();
		
		// Close mobile menu if open
		var mobileMenu = document.getElementById('mobile-menu');
		var mobileToggle = document.getElementById('mobile-menu-toggle');
		var body = document.body;
		if (mobileMenu && mobileMenu.getAttribute('aria-hidden') === 'false') {
			mobileMenu.setAttribute('aria-hidden', 'true');
			if (mobileToggle) {
				mobileToggle.setAttribute('aria-expanded', 'false');
				mobileToggle.classList.remove('open');
				mobileToggle.focus();
			}
			body.classList.remove('mobile-menu-open');
		}
		
		var formSection = document.getElementById('stay-connected');
		
		if (formSection) {
			// Form exists on current page - scroll to it
			smoothScrollTo(formSection);
		} else {
			// Form doesn't exist - navigate to homepage with hash
			window.location.href = e.currentTarget.href;
		}
	}

	function initFormScrollButtons() {
		var scrollButtons = document.querySelectorAll('.js-scroll-to-form');
		
		scrollButtons.forEach(function(button) {
			button.addEventListener('click', handleFormScroll);
		});

		// Handle hash on page load (when coming from another page)
		if (window.location.hash === '#stay-connected') {
			var formSection = document.getElementById('stay-connected');
			if (formSection) {
				setTimeout(function() {
					smoothScrollTo(formSection);
				}, 100);
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFormScrollButtons);
	} else {
		initFormScrollButtons();
	}
})();

// US Residents Modal
(function(){
	if ( typeof document === 'undefined' ) return;

	var STORAGE_KEY = 'us_residents_confirmed';
	var modal = document.getElementById('us-residents-modal');
	var confirmBtn = document.getElementById('modal-confirm');
	var cancelBtn = document.getElementById('modal-cancel');

	if (!modal || !confirmBtn || !cancelBtn) return;

	function hasConfirmed() {
		try {
			return localStorage.getItem(STORAGE_KEY) === 'true';
		} catch (e) {
			// localStorage might be disabled
			return false;
		}
	}

	function setConfirmed() {
		try {
			localStorage.setItem(STORAGE_KEY, 'true');
		} catch (e) {
			// localStorage might be disabled, silently fail
		}
	}

	function showModal() {
		modal.style.display = 'flex';
		document.body.classList.add('modal-open');
		
		// Trigger animation
		setTimeout(function() {
			modal.classList.add('modal-visible');
		}, 10);

		// Focus confirm button for accessibility
		confirmBtn.focus();
	}

	function hideModal() {
		modal.classList.remove('modal-visible');
		
		setTimeout(function() {
			modal.style.display = 'none';
			document.body.classList.remove('modal-open');
		}, 300); // Match CSS transition duration
	}

	function handleConfirm() {
		setConfirmed();
		hideModal();
	}

	function handleCancel() {
		// Redirect to Ascendis Pharma site
		window.location.href = 'https://ascendispharma.us/';
	}

	// Event listeners
	confirmBtn.addEventListener('click', handleConfirm);
	cancelBtn.addEventListener('click', handleCancel);

	// Close on Escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && modal.style.display === 'flex') {
			handleCancel();
		}
	});

	// Trap focus within modal
	modal.addEventListener('keydown', function(e) {
		if (e.key === 'Tab') {
			var focusableElements = [confirmBtn, cancelBtn];
			var firstElement = focusableElements[0];
			var lastElement = focusableElements[focusableElements.length - 1];

			if (e.shiftKey && document.activeElement === firstElement) {
				e.preventDefault();
				lastElement.focus();
			} else if (!e.shiftKey && document.activeElement === lastElement) {
				e.preventDefault();
				firstElement.focus();
			}
		}
	});

	// Show modal on first visit
	function initModal() {
		if (!hasConfirmed()) {
			showModal();
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initModal);
	} else {
		initModal();
	}
})();
// Exit Link Modal
(function(){
	if ( typeof document === 'undefined' ) return;

	var modal = document.getElementById('exit-link-modal');
	var confirmBtn = document.getElementById('exit-confirm');
	var cancelBtn = document.getElementById('exit-cancel');

	if (!modal || !confirmBtn || !cancelBtn) return;

	var exitUrl = ''; // Store the URL to navigate to

	function showModal() {
		modal.style.display = 'flex';
		document.body.classList.add('modal-open');
		
		// Trigger animation
		setTimeout(function() {
			modal.classList.add('modal-visible');
		}, 10);

		// Focus confirm button for accessibility
		confirmBtn.focus();
	}

	function hideModal() {
		modal.classList.remove('modal-visible');
		
		setTimeout(function() {
			modal.style.display = 'none';
			document.body.classList.remove('modal-open');
		}, 300); // Match CSS transition duration
	}

	function handleConfirm() {
		hideModal();
		// Navigate to the exit URL after modal closes
		setTimeout(function() {
			window.location.href = exitUrl;
		}, 300);
	}

	function handleCancel() {
		hideModal();
	}

	// Event listeners
	confirmBtn.addEventListener('click', handleConfirm);
	cancelBtn.addEventListener('click', handleCancel);

	// Close on Escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && modal.style.display === 'flex') {
			handleCancel();
		}
	});

	// Trap focus within modal
	modal.addEventListener('keydown', function(e) {
		if (e.key === 'Tab') {
			var focusableElements = [confirmBtn, cancelBtn];
			var firstElement = focusableElements[0];
			var lastElement = focusableElements[focusableElements.length - 1];

			if (e.shiftKey && document.activeElement === firstElement) {
				e.preventDefault();
				lastElement.focus();
			} else if (!e.shiftKey && document.activeElement === lastElement) {
				e.preventDefault();
				firstElement.focus();
			}
		}
	});

	// Initialize exit link handlers
	function initExitLinks() {
		var exitLinks = document.querySelectorAll('a.exit, .recaptcha-notice a[target="_blank"]');
		
		exitLinks.forEach(function(link) {
			link.addEventListener('click', function(e) {
				// Only prevent default if the link has an href attribute
				if (link.href) {
					e.preventDefault();
					exitUrl = link.href;
					showModal();
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initExitLinks);
	} else {
		initExitLinks();
	}
})();